import * as React from "react";
const SvgAllEnergy = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 35, viewBox: "0 0 16 35", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m15.383 15.077-5.75-.707L11.396-.002.765 19.366l5.75.707-1.763 14.372z", fill: "#2396FD", fillRule: "nonzero" }));
export default SvgAllEnergy;
